import { render, staticRenderFns } from "./PayButton.vue?vue&type=template&id=45a5ba8c&"
import script from "./PayButton.vue?vue&type=script&lang=js&"
export * from "./PayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports